
import { fabric } from 'fabric';
import {Component, Prop, Vue} from 'vue-property-decorator'
import {http} from "@/config/httpCommon";
import {handleResponseException, showResponseErrors, showToast} from "@/helpers/Helpers";
import { ValidationProvider, ValidationObserver, ValidationObserverInstance} from 'vee-validate';
import { isArray } from 'lodash';

@Component<GeneralAction>({
  components: { ValidationProvider, ValidationObserver }
})
export default class GeneralAction extends Vue {
  public anchor_product = ''
  public merge_product = ''
  public from_product = ''
  public to_product = ''
  public company_id = ''
  public styles = []
  public anchor_style = ''
  public merge_style = ''
  public ip = ''
  public from_company = ''
  public to_company = ''
  public email = ''
  public copy_from_company_id = null
  public copy_to_company_id = null
  public to_company_fixed_logo = null
  public copying_company_data = false
  public merge_customer_company_id = '';
  public merge_customer_email = '';
  public from_locker_product = '';
  public to_locker_product = '';
  public currency_obj = {
    name: '',
    symbol: '',
    code: ''
  }
  public changeProduct() {
    if (this.from_product && this.to_product && this.company_id) {
      http.get(`change-product/` + this.from_product + '/' + this.to_product + '/' + this.company_id).then(res => {
        showToast('product changed successfully')
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public mergeProducts() {
    if (this.anchor_product && this.merge_product) {
      http.get(`merge-product-model/` + this.anchor_product + '/' + this.merge_product).then(res => {
        showToast('product merged successfully')
        this.styles = res.data
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public mergeStyles() {
    if (this.anchor_style && this.merge_style) {
      http.get(`merge-product-style/` + this.anchor_style + '/' + this.merge_style).then(res => {
        showToast('style merged successfully')
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public addIpWhitelist() {
    if (this.ip) {
      http.post(`ip-whitelist`, { ip: this.ip }).then(res => {
        showToast(this.ip + ' added to whitelist')
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public moveCustomer() {
    if (this.from_company && this.to_company && this.email) {
      http.post(`move-customer`, { from_company: this.from_company, to_company: this.to_company, email: this.email }).then(res => {
        showToast('Customer data moved successfully')
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public mergeCustomer() {
    if (this.merge_customer_company_id && this.merge_customer_email) {
      http.post(`merge-customer`, { company_id: this.merge_customer_company_id, email: this.merge_customer_email }).then(res => {
        showToast('Customer data merged successfully')
      }).catch(err => {
        showToast(err.response.data, 'error')
      })
    }
  }
  public copyCompanyData() {
    //@ts_ignore
    (this.$refs.copyCompanyDataObserver as ValidationObserverInstance).validate().then((validated) => {
      if (validated) {
        let form_data = new FormData();
        form_data.append('to_company_fixed_logo', this.to_company_fixed_logo)
        this.copying_company_data = true;
        http.post(`clone/company/${this.copy_from_company_id}/in_to/company/${this.copy_to_company_id}`, form_data).then(succeessResponse => {
          const response_data = succeessResponse.data
          this.copying_company_data = false;
          this.copy_from_company_id = null;
          this.copy_to_company_id = null;
          this.to_company_fixed_logo = null;
          (this.$refs.copyCompanyDataObserver as ValidationObserverInstance).reset()
          showToast(response_data.message)
        }, (errorResponse) => {
          this.copying_company_data = false;
          console.log('error', errorResponse)
          showResponseErrors(errorResponse);
        })
      }
    })
  }
  public loadLockerProducts() {
    const base_url = process.env.VUE_APP_FILE_URL
    let locker_url = `get-locker-product-design-svg`
    if (this.from_locker_product && this.to_locker_product) {
      locker_url = `${locker_url}?from_locker_product=${this.from_locker_product}&to_locker_product=${this.to_locker_product}`
    }
    http.get(locker_url).then(res => {
      const locker_products = res.data.locker_products
      locker_products.forEach(async (locker_product) => {
        let design = []
        let svg_parts = []
        const front_design_url = `${base_url}/${locker_product.design.front_design.file_url}`
        const front_svg_objects = await this.loadSVGFromURL(front_design_url);
        design.push(...front_svg_objects);
        if (locker_product.design.back_design) {
          const back_design_url = `${base_url}/${locker_product.design.back_design.file_url}`
          const back_svg_objects = await this.loadSVGFromURL(back_design_url)
          design.push(...back_svg_objects)
        }

        design.forEach((item: Record<any, any>) => {
          if (item.id) {
            item.id = item.id.toLowerCase()
            if (!item.id.includes('noncustomizable') && !item.id.includes('inside') && !svg_parts.includes(item.id)) {
              svg_parts.push(item.id)
            }
          }
        })
        const index = svg_parts.indexOf('base');

        if (index !== -1 && index !== 0) {
          svg_parts.splice(index, 1);
          svg_parts.unshift('base');
        }
        if (svg_parts.length) {
          http.post('save-locker-product-svg-parts', { 'svg_parts': svg_parts, design_id: locker_product.design_id }).then(res => {
            console.log(res.data)
          }).catch(err => {
            showToast(err.response.data, 'error')
          })
        }
      })
    }).catch(err => {
      showToast(err.response.data, 'error')
    })
  }

  public addNewCurrency() {
    (this.$refs['add-new-currency-observer'] as ValidationObserverInstance).validate().then(is_validated => {
      http.post('currency', { ...this.currency_obj }).then(successResponse => {
        showToast(successResponse.data.message, 'success')
      }).catch(errorResponse => {
        handleResponseException(errorResponse)
      })
    })
  }
  private loadSVGFromURL(url): Promise<any[]> {
    return new Promise((resolve) => {
      fabric.loadSVGFromURL(url, (objects: any, options: any) => {
        options.crossOrigin = 'anonymous'
        const svg_objects = isArray(objects) ? objects : [objects]
        resolve(svg_objects)
      })
    })
  }
}
